import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoadingComponent } from '../loading/loading.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-modal-loading',
  templateUrl: './modal-loading.component.html',
  styleUrls: ['./modal-loading.component.scss'],
  standalone: true,
  imports: [CommonModule, LoadingComponent]
})
export class ModalLoadingComponent {
  @ViewChild('loading') loading: LoadingComponent;

  constructor(public dialogRef: MatDialogRef<ModalLoadingComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  close() {
    this.dialogRef.close();
  }

  handleClick(event) {
    this.dialogRef.close();
  }

  stopPropagate(event : Event) {
    event.stopPropagation();
  }
}
